export default "__VITE_ASSET__BqDv$28y__"